var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L16.9998 10.5002L22 19H12H2L7.00019 10.5002L12 2Z",
    stroke: "#FFFEFE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.043 13.05H8.95605V13.9H15.043V13.05Z",
    fill: "#FFFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4343 16.45V10.5H11.5648V16.45H12.4343Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLinkIcon);
export default __webpack_public_path__ + "static/media/menu-link-icon.18575e10313b73424f1f041a9c3975d9.svg";
export { ForwardRef as ReactComponent };